import { v4 as uuidv4 } from "uuid";

// Session/persistence model (see src/components/ChatPanel/README.md):
// a client-generated UUID session id is persisted in localStorage and sent
// on every chat/reset/history call. Redux state alone doesn't survive a
// hard reload, so a sessionStorage marker is used to remember "the user just
// reset" across a reload (otherwise a reload right after a reset would look
// indistinguishable from "just never loaded history yet" and would restore
// the pre-reset thread from the server).
const SESSION_ID_KEY = "myracle.chat.sessionId";
const JUST_RESET_KEY = "myracle.chat.justReset";

export const getOrCreateSessionId = () => {
  let sessionId = localStorage.getItem(SESSION_ID_KEY);
  if (!sessionId) {
    sessionId = uuidv4();
    localStorage.setItem(SESSION_ID_KEY, sessionId);
  }
  return sessionId;
};

export const createNewSessionId = () => {
  const sessionId = uuidv4();
  localStorage.setItem(SESSION_ID_KEY, sessionId);
  return sessionId;
};

export const markSessionJustReset = () => {
  sessionStorage.setItem(JUST_RESET_KEY, "true");
};

// Reads (and clears) the "just reset" marker. Only meant to be consulted
// once, at boot.
export const consumeSessionJustResetMarker = () => {
  const wasJustReset = sessionStorage.getItem(JUST_RESET_KEY) === "true";
  sessionStorage.removeItem(JUST_RESET_KEY);
  return wasJustReset;
};
